module.exports = __webpack_public_path__ + "static/img/bg-pt.9dc6eb47.png";